module.exports = __webpack_public_path__ + "public/images/prizes/prize-uae-4.7d5e5f7e789b1389ca83c54def1d0026.jpg";